<template>
  <d-container class="h-100">
    <d-row class="h-100 align-items-center">
      <d-col class="main-content p-0" tag="main" sm="12">
        <div class="new-pass-form__title">{{ $t('newPassword.title') }}</div>

        <p class="new-pass-form__label">{{ $t('newPassword.oldPass') }}</p>

        <input
          @keydown.enter="sendNewPass()"
          class="input input--user input--no-icon"
          type="text"
          :placeholder="$t('newPassword.placeholders.pass')"
          v-model="form.oldPassword"
          required
        >

        <p class="new-pass-form__label">{{ $t('newPassword.newPass') }}</p>

        <input
          @keydown.enter="sendNewPass()"
          class="input input--pass input--no-icon"
          type="password"
          :placeholder="$t('newPassword.placeholders.pass')"
          v-model="form.newPassword"
          required
        >

        <p class="new-pass-form__label">{{ $t('newPassword.confirmNewPass') }}</p>

        <input
          @keydown.enter="sendNewPass()"
          class="input input--pass input--no-icon"
          type="password"
          :placeholder="$t('newPassword.placeholders.pass')"
          v-model="form.confirmNewPassword"
          ref="confirmPass"
          required
        >

        <div class="new-pass-form__control control">
          <div class="control__error">
            <span v-if="error">{{ error }}</span>
            <md-spinner v-if="loading" md-indeterminate></md-spinner>
          </div>

          <div class="control__send">
            <div
              @click="sendNewPass()"
              class="btn btn--small btn--swidth"
            >{{ $t('newPassword.send_button') }}</div>
          </div>
        </div>
      </d-col>
    </d-row>
  </d-container>
</template>

<script>
export default {
  name: 'new-password',
  data() {
    return {
      form: {
        oldPassword: null,
        newPassword: null,
        confirmNewPassword: null,
      },
      loading: false,
      error: false,
    };
  },
  methods: {
    sendNewPass() {
      this.error = false;
      this.loading = true;

      if (this.form.newPassword !== this.form.confirmNewPassword) {
        this.error = this.$t('newPassword.error_confirm');

        this.loading = false;
      } else {
        // console.log('UHU')
      }
    },
  },
};
</script>

<style lang="scss" scoped>
// @import '~_sass_config/vars';
// @import '~_sass_config/mixins';

// .new-pass-form {
//     color: $color-white--base;

//     input {
//         margin: 10px 0;
//     }

//     &__title {
//         color: $color-white--base;
//         font-size: rem(18px);
//         margin: 0 0 15px 0;
//     }

//     &__label {
//         color: $color-white--base;
//         font-size: rem(10px);
//         font-weight: bold;
//         text-transform: uppercase;
//         text-align: left;

//         width: 100%;
//     }
//     &__control {
//         display: flex;
//         justify-content: space-between;
//     }

//     .control {
//         &__error {
//                 font-size: rem(12px);
//                 font-weight: bold;
//                 color: $color-warn;

//                 display: flex;
//             }
//             &__send {
//                 display: flex;
//                 flex-direction: column;
//                 align-items: flex-end;

//                 min-width: 150px;
//             }
//     }
// }
</style>
